import { Stack, Text } from '@chakra-ui/react'

import {
  SUMMER_CAMP_COLORS,
  SUMMER_CAMP_END_DATE,
  SUMMER_CAMP_ICON,
  SUMMER_CAMP_START_DATE,
  SUMMER_CAMP_YEAR,
} from '@/client/services/summerCamp'

import ShwLink from '@/components/ShwLink'
import type { FormInputType } from '@/components/UI/Form/types'
import Icon from '@/components/UI/Icon/Icon'

import { getSummerCampUrl } from '../url'

export default function getSummerCampFormInput({
  type,
  initialValue,
}: {
  type: 'session' | 'series'
  initialValue?: boolean
}): FormInputType {
  return {
    label:
      `Would you like to add this ${type} to Summer Camp ${SUMMER_CAMP_YEAR}, which takes place from ` +
      `${SUMMER_CAMP_START_DATE.toFormat('MMMM d')} to ` +
      `${SUMMER_CAMP_END_DATE.toFormat('MMMM d')}?`,
    type: 'multi-checkbox',
    name: 'isSummerCamp',
    required: false,
    sublabel: (
      <Text variant="supporting" color="fg.subtle">
        Summer Camp sessions are typically extracurricular sessions where tutors share their hobbies
        & interests with the community.{' '}
        <ShwLink href={getSummerCampUrl()} isExternal>
          Learn More
        </ShwLink>
      </Text>
    ),
    options: [
      {
        value: 'yes',
        label: (
          <Stack direction="row" align="center" spacing="8px" pt="3px">
            <Text color={SUMMER_CAMP_COLORS.primaryColor} fontWeight="bold">
              Yes, add my {type} to Summer Camp!
            </Text>
            <Icon size="md" faIcon={SUMMER_CAMP_ICON} color={SUMMER_CAMP_COLORS.primaryColor} />
          </Stack>
        ),
      },
    ],
    initialValue: initialValue === true ? ['yes'] : [],
    size: 6,
  }
}
